import Component from '@glimmer/component';
import { t } from 'ember-intl';
import RocketButton from 'madow-tech/components/rocket-button';
import SpaceCard from 'madow-tech/components/space-card';

export default class RatesBanner extends Component {
  handleCtaClick() {
    window.location.href = '#contact';
  }

  <template>
    <section class="py-10" aria-label="Rates & Availability">
      <div class="mx-auto max-w-7xl px-4">
        <SpaceCard
          @variant="v4"
          @hasHoverEffect={{true}}
          class="backdrop-blur shadow-[0_0_80px_-30px_rgba(244,63,94,0.35)]"
        >
          <div
            class="flex flex-col md:flex-row md:items-center md:justify-between gap-4"
          >
            <p class="text-sm md:text-base text-rose-100">{{t "ratesBanner.line1"}}</p>
            <RocketButton @text={{t "ratesBanner.cta.label"}} @sectionId="contact" />
          </div>
        </SpaceCard>
      </div>
    </section>
  </template>
}
